import * as React from 'react'
import { dispatchToProps, IVoiceSampleListContainerProps } from './VoiceSampleList.container'
import { IVoiceBunnySample } from '../types'
import { Table, TableHeader, TableRow } from 'features/Table'
import Button from 'components/Button'
import * as sMarg from 'styles/modules/margins.scss'
import * as sLay from 'styles/modules/layout.scss'
import * as s from './VoiceSampleList.scss'
import { Field } from 'redux-form'
import LoadingLinear from 'components/Loading/LoadingLinear'
import SelectPretty from 'components/Input/SelectPretty'
import cn from 'classnames'
import { orderBy } from 'lodash'

const voiceTypeOptions = [
  {
    value: '',
    name: 'Any',
  },
  {
    value: 'youngAdultMale',
    name: 'Male | Young adult',
  },
  {
    value: 'middleAgeMale',
    name: 'Male | Middle age',
  },
  {
    value: 'youngAdultFemale',
    name: 'Female | Young adult',
  },
  {
    value: 'middleAgeFemale',
    name: 'Female | Middle age',
  },
]

const voiceLanguageOptions = [
  {
    value: 'eng-au',
    name: 'English (AU)',
  },
  {
    value: 'eng-nz',
    name: 'English (NZ)',
  },
  {
    value: 'eng-us',
    name: 'English (US)',
  },
  {
    value: 'eng-uk',
    name: 'English (UK)',
  },
  {
    value: 'cmn-zh',
    name: 'Mandarin',
  },
  {
    value: 'yue-zh',
    name: 'Cantonese',
  },
  {
    value: 'ara',
    name: 'Arabic',
  },
  {
    value: 'vie-vi',
    name: 'Vietnamese',
  },
  {
    value: 'ita-it',
    name: 'Italian',
  },
  {
    value: 'ell-el',
    name: 'Greek',
  },
]

export interface IVoiceSampleListComponentProps extends IVoiceSampleListContainerProps {
  loading: boolean
  results: IVoiceBunnySample[]
  getSamples: typeof dispatchToProps['getSamples']
  cacheKey: string
}

export class VoiceSampleListComponent extends React.Component<IVoiceSampleListComponentProps> {
  componentWillMount() {
    const { getSamples, cacheKey, filter } = this.props
    getSamples({ cacheKey, filter })
  }
  componentWillReceiveProps(nextProps: IVoiceSampleListComponentProps) {
    if (nextProps.cacheKey !== this.props.cacheKey) {
      const { getSamples, filter, cacheKey } = nextProps
      getSamples({ filter, cacheKey })
    }
  }
  render() {
    const { results, loading, onSelect, talendID } = this.props

    const tableHeader = (
      <TableHeader>
        <div style={{ maxWidth: '100px' }}>Actor ID</div>
        <div style={{ maxWidth: '110px' }} className={sLay['hide-xs']}>
          Price
        </div>
        <div className={sLay['hide-xs']}>Sample</div>
        <div style={{ maxWidth: '82px' }} />
      </TableHeader>
    )

    return (
      <div>
        <div className={cn(sLay['layout-row'], sLay['layout-align-end'], sMarg.mb30)}>
          <div style={{ marginRight: '5px' }}>
            <Field
              label="Voice Type"
              component={SelectPretty}
              className={s.select}
              options={voiceTypeOptions}
              display="box"
              name="filter.genderAndAge"
            />
          </div>
          <Field
            label="Language"
            component={SelectPretty}
            className={s.select}
            options={voiceLanguageOptions}
            display="box"
            name="filter.language"
          />
        </div>
        <Table header={tableHeader} className={s.table}>
          {orderBy(results, 'price', 'asc').map((result, idx) => (
            <TableRow key={idx}>
              <div style={{ maxWidth: '100px' }}>{result.talentID}</div>
              <div style={{ maxWidth: '110px' }}>${result.price}/min</div>
              <div>
                <audio controls style={{ width: '100%' }}>
                  <source src={result.url} type="audio/mpeg" />
                </audio>
              </div>
              <div style={{ maxWidth: '82px' }}>
                <Button
                  onClick={() => onSelect(result)}
                  color="tertiary"
                  size="xs"
                  ghost={talendID !== result.talentID}
                  type="submit"
                >
                  Select
                </Button>
              </div>
            </TableRow>
          ))}
          {results.length === 0 && !loading && <TableRow>No results</TableRow>}
          {loading && (
            <div>
              <br />
              <br />
              <LoadingLinear />
            </div>
          )}
        </Table>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/features/Voices/VoiceSampleList/VoiceSampleList.tsx